import { createApp } from "vue";
import App from "./App.vue";
import PrimeVue from "primevue/config";
import "frontend-component-templates/src/styles/main.scss";
import { PRIMEVUE_CONFIG } from "frontend-component-templates/src/store/primevue";
import "./styles/website.scss";

if (document.getElementById("quote-calculation")) {
  createApp(App).use(PrimeVue, PRIMEVUE_CONFIG).mount("#quote-calculation");
}
